import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { entityName } from '@qtek/shared/models';

import { HttpEntityManager } from './../http-entity-manager';

@Injectable({
  providedIn: 'root',
})
export class PersonService extends HttpEntityManager<any, any> {
  protected http = inject(HttpClient);

  entityName: entityName = 'prs';

  constructor() {
    super(true);
  }

  updatePerson(payload: any, additionalPayload: any = {}) {
    return super.put(payload, null, additionalPayload);
  }
}
